import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import shortId from 'shortid';
import { ActionState, messages as commonMessages } from 'common';
import { FormattedMessage } from 'react-intl';
import { Field, reduxForm } from 'redux-form';
import { ControlLabel } from 'react-bootstrap';
import styles from './styles.css';
import messages from './messages';

const ActionsForm = ({ actions, hasActionResolvableByCurrentUser, handleSubmit }) => {
  const [checkBoxesState, setCheckBoxesState] = useState(actions.map(() => false));
  const [isDisabled, setIsDisabled] = useState(false);

  /* update isDisabled to true if any checkbox is checked */
  function onCheckBoxChange(index, value) {
    const updatedCheckBoxes = [...checkBoxesState];
    updatedCheckBoxes[index] = value;
    setCheckBoxesState(updatedCheckBoxes);
    setIsDisabled(updatedCheckBoxes.includes(true));
  }

  /* Reset checkbox and button to default state */
  function onSubmit(e) {
    e.preventDefault();
    setCheckBoxesState(actions.map(() => false));
    setIsDisabled(false);
    handleSubmit();
  }

  const transferHasActions = actions.length > 0;
  const transferHasOpenActions = actions.some((action) => action.status === ActionState.Open);
  return (
    <form onSubmit={onSubmit} className={styles.form}>
      {!transferHasActions > 0 &&
        // If the transfer has no actions available, show a message.
        <p><FormattedMessage {...messages.noActions} /></p>
      }
      {(transferHasActions && !hasActionResolvableByCurrentUser && transferHasOpenActions) &&
        // If the transfer has open actions available, but the user can't perform them, show a different message.
        <p><FormattedMessage {...messages.noActionsResolvableByCurrentUser} /></p>
      }
      {(transferHasActions && !transferHasOpenActions) &&
        // If the transfer has actions, but they are not open, show a different message.
        <p><FormattedMessage {...messages.allActionsApproved} /></p>
      }
      {transferHasActions &&
        <div className={transferHasOpenActions ? styles.checkboxes : styles.tallCheckboxes}>
          {
            actions.map((action, index) => {
              // Grey out the label text if it can't be resolved by the user.
              const extraStyles = action.isResolvableByCurrentUser ? null : styles.disabled;
              // Translate the role if we know how, otherwise display the raw api value.
              const roleMessage = commonMessages[action.role] ? <FormattedMessage {...commonMessages[action.role]} /> : action.role;
              const htmlId = shortId.generate();
              return (
                <ControlLabel
                  className={classNames(styles.checkboxLabel, extraStyles)}
                  htmlFor={htmlId}
                  key={action.id}
                  data-test-type={action.type}
                >
                  <Field
                    id={htmlId}
                    name={action.id}
                    className={styles.checkboxInput}
                    disabled={!action.isResolvableByCurrentUser}
                    component="input"
                    type="checkbox"
                    onChange={(e, value) => (onCheckBoxChange(index, value))}
                  />
                  {action.reason}
                  <i className={styles.actionRole} data-test-role={action.role}>
                    <FormattedMessage {...messages.department} /> {roleMessage}
                  </i>
                </ControlLabel>
              );
            })}
        </div>
      }
      {(hasActionResolvableByCurrentUser && transferHasOpenActions) &&
        <div className={styles.commentContainer}>
          <ControlLabel className={styles.commentLabel} htmlFor="action-comments">
            <FormattedMessage {...messages.comments} />
            <Field className={styles.commentInput} component="textarea" name="comment" id="action-comments" />
          </ControlLabel>
          <button type="submit" className="buttons-primary buttons btn-right" data-test-handle="submitActions" disabled={!isDisabled}>
            <FormattedMessage {...messages.submit} />
          </button>
        </div>
      }
    </form>
  );
};

ActionsForm.propTypes = {
  actions: PropTypes.array.isRequired,
  hasActionResolvableByCurrentUser: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

export default reduxForm({ form: 'Actions', enableReinitialize: true })(ActionsForm);



// WEBPACK FOOTER //
// ./src/components/ActionsForm/index.js